import { PlannerPoi } from '../components/common/types/Planner.types';

export interface POIRawResponse {
  geometry: {
    coordinates: [number, number];
    type: string;
  };
  properties: {
    address: string;
    categoryName: string;
    categoryType: string;
    dataProvider: string;
    latitude: number;
    longitude: number;
    mediaOwner: string;
    poiId: string;
    poiName: string;
    postalCode: string;
    include?: boolean;
    radius?: number;
  };
  type: string;
}

export const transformPoiRawData = (poiRawData: POIRawResponse[]): PlannerPoi[] =>
  poiRawData.map((rawPoi) => ({
    id: rawPoi.properties.poiId,
    name: rawPoi.properties.poiName || rawPoi.properties.categoryName,
    geometry: {
      coordinates: [
        rawPoi.properties.longitude ?? rawPoi.geometry?.coordinates?.[0],
        rawPoi.properties.latitude ?? rawPoi.geometry?.coordinates?.[1],
      ],
    },
    properties: {
      categoryName: rawPoi.properties?.categoryName || '',
      categoryType: rawPoi.properties?.categoryType || '',
      address: rawPoi.properties?.address || '',
      postalCode: rawPoi.properties?.postalCode || '',
      dataProvider: rawPoi.properties?.dataProvider || '',
      mediaOwner: rawPoi.properties?.mediaOwner || '',
      type: rawPoi.geometry?.type || '',
      visibility: {
        include: rawPoi.properties?.include ?? true,
        radius: rawPoi.properties?.radius ?? 0,
      },
    },
  }));
